module.exports = __webpack_public_path__ + "static/media/caradvise-instacart-logo.85984278.svg";